module.exports = __webpack_public_path__ + "static/media/fnb.c032905a.jpeg";